import type { FaireProductEntity } from "../../entity_types/product";

export const p_mz5jay5xsm: FaireProductEntity = {
  token: "p_mz5jay5xsm",
  type: "product",
  name: "SKIN & LACE - Lace Slingback",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/a85408f93f3df0aa5d51dad7b9f522e95180fe31efa8e93b57f2062ed40e3e5f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c54471f6f76f917204acf42f0e92066d4095a6e3bd6a2e9ff165d744ed1d0b4.jpeg",
    "https://cdn.faire.com/fastly/12a27f66c262fd49879b70f0dc756700479c1568d86bfa36c9266cecd3644871.jpeg",
    "https://cdn.faire.com/fastly/07cb740cbcb082a1141e81b0bfcbfe0af846298dfc0b448f937e3aeead9c4a1d.jpeg",
    "https://cdn.faire.com/fastly/92a08253c4fd426d1c331114e6c9f94af8a00d4a0bda9a2ceeefc948ce529687.jpeg",
  ],
  priceDollars: 12.75,
  description:
    "Delicate yet striking, these lace slingback pumps bring timeless romance to every step. Designed with sheer floral lace, a sleek pointed toe, and a feminine slingback strap, they create an elegant silhouette that's both lightweight and sophisticated. Available in soft butter yellow, ivory, black, and rich burgundy, they're the perfect statement heel for weddings, parties, or elevated everyday styling.\nOOTD\nStyle them with a satin midi dress or tailored wide-leg trousers for an effortlessly polished look. For a softer, romantic outfit, pair them with a floral maxi dress or lace-trim skirt. Complete the look with pearl jewelry and a structured mini bag to highlight the delicate lace detailing.",
  tags: [],
  msrpDollars: 25.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:15.203Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
